<div
  class="relative z-10"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
  *ngIf="appService.isModalStarterFreeOpen | async"
  (click)="appService.toggleModalStarterFree()"
>
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div
      class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
    >
      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-left shadow-xl transition-all my-8 w-full max-w-md"
        (click)="$event.stopPropagation()"
      >
        <div
          class="absolute top-4 right-4 cursor-pointer"
          (click)="appService.toggleModalStarterFree()"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.281 18.2193C19.3507 18.289 19.406 18.3717 19.4437 18.4628C19.4814 18.5538 19.5008 18.6514 19.5008 18.7499C19.5008 18.8485 19.4814 18.9461 19.4437 19.0371C19.406 19.1281 19.3507 19.2109 19.281 19.2806C19.2114 19.3502 19.1286 19.4055 19.0376 19.4432C18.9465 19.4809 18.849 19.5003 18.7504 19.5003C18.6519 19.5003 18.5543 19.4809 18.4632 19.4432C18.3722 19.4055 18.2895 19.3502 18.2198 19.2806L12.0004 13.0602L5.78104 19.2806C5.64031 19.4213 5.44944 19.5003 5.25042 19.5003C5.05139 19.5003 4.86052 19.4213 4.71979 19.2806C4.57906 19.1398 4.5 18.949 4.5 18.7499C4.5 18.5509 4.57906 18.36 4.71979 18.2193L10.9401 11.9999L4.71979 5.78055C4.57906 5.63982 4.5 5.44895 4.5 5.24993C4.5 5.05091 4.57906 4.86003 4.71979 4.7193C4.86052 4.57857 5.05139 4.49951 5.25042 4.49951C5.44944 4.49951 5.64031 4.57857 5.78104 4.7193L12.0004 10.9396L18.2198 4.7193C18.3605 4.57857 18.5514 4.49951 18.7504 4.49951C18.9494 4.49951 19.1403 4.57857 19.281 4.7193C19.4218 4.86003 19.5008 5.05091 19.5008 5.24993C19.5008 5.44895 19.4218 5.63982 19.281 5.78055L13.0607 11.9999L19.281 18.2193Z"
              fill="black"
            />
          </svg>
        </div>
        <div class="flex flex-col">
          <img src="assets/imgs/banners/free-modal.png" />
        </div>
        <div class="bg-white px-4 pb-4 pt-5">
          <div class="flex flex-col">
            <h3 class="text-xl text-center mt-4 mb-2 text-gray-900 font-medium">
              Cadastre-se e tenha acesso livre<br />
              durante 90 dias à nossa<br />
              plataforma*.
            </h3>
            <p class="text-sm text-center text-gray-500">
              *Válido nas modalidades presencial e delivery
            </p>
          </div>
        </div>
        <div class="px-4 py-3 flex justify-evenly gap-5 mb-4">
          <a
            href="https://wa.me/5551989687886?text=Tenho%20interesse%20nos%2090%20dias%20free%20do%20Mobo"
            target="_blank"
            rel="noopener noreferrer"
            type="button"
            class="grow flex gap-2 items-center w-full justify-center rounded-full bg-white p-3 text-sm text-green-500 shadow-sm ring-1 ring-inset ring-green-500 hover:bg-green-500 hover:text-white sm:mt-0 sm:w-auto"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2502 16.5C12.4606 16.498 10.7448 15.7862 9.4794 14.5208C8.21396 13.2553 7.50216 11.5396 7.50017 9.75C7.50003 9.2298 7.68014 8.72562 8.00986 8.32326C8.33958 7.9209 8.79853 7.64521 9.30861 7.54313L10.3849 9.69938L9.46892 11.0625C9.40048 11.1652 9.35842 11.2831 9.34649 11.406C9.33455 11.5288 9.3531 11.6526 9.40049 11.7666C9.9371 13.0419 10.9517 14.0565 12.227 14.5931C12.3413 14.6426 12.4661 14.6629 12.5902 14.6521C12.7143 14.6413 12.8337 14.5998 12.9377 14.5312L14.3074 13.6181L16.4636 14.6944C16.3607 15.205 16.0838 15.6642 15.6802 15.9935C15.2765 16.3228 14.7711 16.5018 14.2502 16.5ZM12.0002 2.25C10.3169 2.24963 8.66213 2.68508 7.19704 3.51396C5.73194 4.34285 4.50641 5.53692 3.63971 6.97997C2.77302 8.42301 2.29469 10.0659 2.25129 11.7486C2.20789 13.4314 2.60089 15.0967 3.39205 16.5825L2.32799 19.7747C2.23985 20.039 2.22706 20.3226 2.29105 20.5938C2.35504 20.8649 2.49328 21.1129 2.69029 21.3099C2.88729 21.5069 3.13526 21.6451 3.40642 21.7091C3.67757 21.7731 3.96119 21.7603 4.22549 21.6722L7.41768 20.6081C8.72527 21.3036 10.1741 21.6921 11.6543 21.744C13.1344 21.7959 14.6069 21.51 15.9601 20.9079C17.3132 20.3057 18.5114 19.4033 19.4636 18.269C20.4159 17.1346 21.0972 15.7983 21.4559 14.3613C21.8146 12.9244 21.8412 11.4246 21.5337 9.97578C21.2263 8.52701 20.5928 7.16732 19.6813 5.99992C18.7699 4.83253 17.6045 3.88811 16.2736 3.23836C14.9427 2.58861 13.4812 2.25061 12.0002 2.25ZM12.0002 20.25C10.5498 20.251 9.12495 19.8691 7.86955 19.1428C7.77763 19.0895 7.67544 19.0563 7.56974 19.0455C7.46404 19.0347 7.35724 19.0464 7.25643 19.08L3.75018 20.25L4.91924 16.7438C4.95294 16.643 4.96485 16.5362 4.95418 16.4305C4.94351 16.3248 4.91051 16.2226 4.85736 16.1306C3.94796 14.5584 3.58284 12.7299 3.81864 10.929C4.05444 9.12801 4.87798 7.4552 6.16151 6.17006C7.44503 4.88491 9.11679 4.05925 10.9175 3.82118C12.7181 3.5831 14.547 3.94591 16.1204 4.85333C17.6938 5.76074 18.9238 7.16204 19.6196 8.83983C20.3153 10.5176 20.4379 12.3781 19.9684 14.1327C19.4989 15.8873 18.4634 17.4379 17.0227 18.5439C15.582 19.65 13.8165 20.2497 12.0002 20.25Z"
                fill="currentColor"
              />
            </svg>
            Falar com nosso time
          </a>
          <a
            href="https://backoffice.mobo.com.br/#/onboarding?starter=true"
            target="_blank"
            rel="noopener noreferrer"
            type="button"
            class="grow flex gap-2 items-center w-full justify-center rounded-full bg-red-600 text-white hover:bg-red-500 p-3 text-sm shadow-sm sm:w-auto"
          >
            Cadastrar
          </a>
        </div>
        <div
          class="flex gap-2 items-center text-sm font-thin justify-center bg-green-800 p-2"
        >
          <img src="assets/imgs/icons/rs.png" alt="Bandeira RS" />
          <p class="text-white">EM APOIO AOS ESTABELECIMENTOS DO RS</p>
        </div>
      </div>
    </div>
  </div>
</div>
